<template>
  <div class="cart__product product" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
    <router-link
      v-if="item.product.id"
      :to="{ name: 'ProductDetail', params: { id: item.product.id } }"
      class="product__image-container"
    >
      <img
        class="product__image"
        alt=""
        v-if="item.product.photos[0]"
        :src="imagesurl + '600/' + item.product.photos[0].name"
      />
      <img v-else class="product__image" src="/static/img/600x400.jpg" alt="" />
    </router-link>
    <div class="product__info-container">
      <div class="product__info-main">
        <div class="product__name-container">
          <h3 class="product__name">{{ item.product.label }}</h3>
        </div>
        <div class="product__price-container">
          <div v-for="productPrice in item.product.prices">
            <span class="product__price" v-if="productPrice.entreprise_description == 'MCI'"
              ><strong>{{ productPrice.price }}</strong> <sup><strong>€</strong> HT</sup></span
            >
          </div>
          <p class="product__price-text">Prix à l'unité</p>
        </div>
      </div>
      <p class="product__code">Code article : {{ item.product.code }}</p>
      <div class="product__tech-container technicien" v-if="forUser.id != me.id">
        <span class="tech__text">Technicien : </span>
        <span class="tech__selector">{{ forUser.firstname }} {{ forUser.lastname }}</span>
      </div>
    </div>
    <div class="product__btns">
      <div class="product__quantity-container quantity">
        <span class="quantity__text">Quantité : </span>
        <input
          type="text"
          class="quantity__value"
          name=""
          :value="item.quantity"
          @change="updateQuantity(item.id)"
        />
      </div>
      <router-link
        v-if="item.product.id"
        :to="{ name: 'ProductDetail', params: { id: item.product.id } }"
        class="product__btn product__btn--see"
      >
        <img src="/static/img/pictos/flecheblanche.svg" alt="" />
      </router-link>
      <a href="" class="product__btn product__btn--delete" @click.prevent="removeFromCart(item.id)">
        <img src="/static/img/pictos/supprimer.svg" class="" />
      </a>
    </div>
  </div>
  <div class="cart__product product product--mobile" v-else>
    <router-link
      v-if="item.product.id"
      :to="{ name: 'ProductDetail', params: { id: item.product.id } }"
      class="product__image-container"
    >
      <img
        class="product__image"
        alt=""
        v-if="item.product.photos && item.product.photos[0]"
        :src="imagesurl + '600/' + item.product.photos[0].name"
      />
      <img v-else class="product__image" src="/static/img/600x400.jpg" alt="" />
    </router-link>
    <div class="product__info-container">
      <div class="product__info-main">
        <div class="product__name-container">
          <h3 class="product__name">{{ item.product.label }}</h3>
        </div>
      </div>
      <p class="product__code">
        <img src="/static/img/pictos/reapprobleufonce.svg" alt="" /><span
          >Code article : {{ item.product.code }}</span
        >
      </p>
    </div>
    <div class="product__quantity-container quantity">
      <span class="quantity__text">Quantité : </span>
      <input
        type="text"
        class="quantity__value"
        name=""
        :value="item.quantity"
        @change="updateQuantity(item.id)"
      />
    </div>
    <div class="product__btns">
      <router-link
        v-if="item.product.id"
        :to="{ name: 'ProductDetail', params: { id: item.product.id } }"
        class="product__btn product__btn--see"
      >
        <img src="/static/img/pictos/flecheblanche.svg" alt="" />
      </router-link>
      <a href="" class="product__btn product__btn--delete" @click.prevent="removeFromCart(item.id)">
        <img src="/static/img/pictos/supprimer.svg" class="" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductCart",
  props: ["item", "addable", "nbProducts", "forUser"],
  data() {
    return {
      // quantity: ''
    };
  },
  created() {},
  methods: {
    removeFromCart(id) {
      self = this;
      self.$store.dispatch("showLoader");
      this.$http
        .delete("orderline/" + id, {})
        .then((response) => {
          self.$store.dispatch("order/getMyCart").then(function () {
            self.$store.dispatch("hideLoader");
          });
          self.$toastr.success(self.$i18n.t("success.cart.deleted"));
        })
        .catch((error) => {});
    },
    updateQuantity(id) {
      self = this;
      this.$http
        .patch("orderline/" + id, {
          quantity: event.target.value,
          id: id,
        })
        .then((response) => {
          //self.$store.dispatch('showLoader');
          self.$toastr.success(self.$i18n.t("success.cart.updated"));
          self.$store.dispatch("order/getMyCart").then(function () {
            //self.$store.dispatch('hideLoader');
          });
        })
        .catch((error) => {});
    },
  },
  computed: {
    myTechs: function () {
      let myTechs = this.$store.getters["auth/myTechs"];

      if (typeof myTechs == "string") {
        return JSON.parse(myTechs);
      } else {
        return myTechs;
      }
    },
    imagesurl() {
      return process.env.BACK_UPLOADS_URL;
    },
    me: function () {
      let me = this.$store.getters["auth/user"];

      if (typeof me == "string") {
        return JSON.parse(me);
      } else {
        return me;
      }
    },
  },
  mounted() {},
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.product {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  padding-top: 15px;
  background-color: white;
  width: 100%;
  height: auto;
  border-bottom: 1px solid $grisclair;
  &__image-container {
    width: 40%;
    min-width: 100px;
    height: 90px;
  }
  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &__info-container {
    flex: 1;
    height: 100%;
    padding: 0 10px;
  }
  &__info-main {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    align-items: top;
    .product__name-container {
      flex: 1;
      line-height: 1;
    }
    .product__price-container {
      width: 110px;
      text-align: left;
      line-height: 1;
      padding-left: 20px;
    }
  }
  .quantity {
    flex: 1;
    &__text {
      color: $grisfonce;
      font-family: "ClanPro";
      text-transform: uppercase;
      font-size: 12px;
      margin-left: 20px;
    }
    &__value {
      width: 55px;
      height: 55px;
      border-radius: 50%;
      background-color: $grisclair;
      display: inline-block;
      line-height: 55px;
      text-align: center;
      border: none;
      margin-bottom: 15px;
      outline: none;
      margin-left: 5%;
      font-family: "ClanFFBlack";
      font-weight: normal;
      color: $color1;
    }
  }
  .tech {
    vertical-align: top;
    &__text {
      font-size: 12px;
      color: $grisfonce;
      font-family: "ClanPro";
      width: 105px;
      display: inline-block;
      text-align: right;
      vertical-align: top;
    }
    &__selector {
      font-size: 12px;
      color: $grisfonce;
      font-family: "ClanPro";
      padding: 5px 10px;
      border: 1px solid $color1;
      margin-left: 5px;
      width: calc(100% - 120px);
      min-width: 105px;
      display: inline-block;
      vertical-align: top;
    }
  }
  .technicien {
    margin-top: 10px;
  }
  &__name {
    font-size: 15px;
    text-transform: uppercase;
    font-family: "ClanFFBlack";
    color: $mystockblue;
  }
  &__price {
    font-size: 25px;
    color: $color2;
    white-space: nowrap;
    strong {
      font-family: "ClanFFBlack";
      font-weight: normal;
    }
    sup {
      font-size: 10px;
      font-family: "ClanPro";
    }
  }
  &__price-text {
    font-size: 10px;
    font-family: "ClanPro";
    color: $color2;
  }
  &__code {
    font-size: 12px;
    color: $grisfonce;
    font-family: "ClanPro";
    display: flex;
    align-items: center;
    img {
      width: 20px;
      margin-right: 5px;
    }
    span {
      margin-top: 1px;
    }
  }
  &__btns {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-end;
    margin-top: 20px;
    width: 100%;
  }
  &__btn {
    width: 80px;
    text-align: center;
    height: 40px;
    color: white;
    line-height: 36px;
    &--see {
      background-color: $color2;
    }
    &--add {
      background-color: $color3;
    }
    img {
      width: 16px;
    }
    &--delete {
      background-color: $color1;
      img {
        width: 12px;
      }
    }
  }
  &--in-content {
    padding-top: 0;
    min-width: 405px;
    .product__image-container {
      width: 40%;
      height: auto;
    }
    .product__info-container {
      width: 60%;
      flex: auto;
      height: auto;
      padding-top: 10px;
    }
  }
  &--mobile {
    position: relative;
    margin-bottom: 50px;
    padding-top: 0;
    border: 1px solid $grisclair;
    .product__btns {
      position: absolute;
      bottom: -40px;
      justify-content: flex-end;
      .product__btn.product__btn--delete {
        img {
          width: 20px;
        }
      }
    }
    .product__image-container {
      width: 50%;
    }
    .product__info-container {
      width: 50%;
      flex: auto;
      padding: 20px;
    }
    .product__quantity-container {
      width: 100%;
      margin-top: 20px;
    }
    .quantity__value {
      margin-left: 10px;
    }
  }
}
@media screen and (max-width: 1680px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductCart.vue